module.exports = __webpack_public_path__ + "static/media/BRITANNIA_F1.a8bf73c2.txt";